import React from 'react';
import foxMaskImage from '../../foxmask.png';
import PartnerCutoutSpiritOverlay from './PartnerCutoutSpiritOverlay';
import './FriendFoxMaskPlaceholderCutout.css';

/**
 * Fox-mask pending cutout: icon + "your masked photo here" (survey-style frame; CSS uppercases).
 * @param {'main'|'feed'|'thumb'} variant
 */
export default function FriendFoxMaskPlaceholderCutout({
  variant = 'feed',
  jaggedClassName = '',
  heartSrc,
  animateHeart = true,
  pauseHeartOffCenter = false,
  captureHeartStill = true,
  heartClassName = 'partner-cutout-gif-overlay',
  label = 'your masked photo here',
  showHeartOverlay = true,
  /** When false, omit `.final-partner-image-wrapper` so the parent can own the wrapper (e.g. editor click target). */
  includeOuterImageWrapper = true,
  heartOverlayInteractive = false,
  onHeartOverlayClick,
  onHeartOverlayKeyDown,
  heartOverlayAriaLabel = 'Change spirit GIF',
}) {
  const isThumb = variant === 'thumb';
  if (isThumb) {
    return (
      <div
        className="friend-foxmask-placeholder-cutout friend-foxmask-placeholder-cutout--thumb"
        title={label}
      >
        <div className="friend-foxmask-placeholder-cutout__icon-wrap">
          <img src={foxMaskImage} alt="" className="friend-foxmask-placeholder-cutout__icon-img" />
        </div>
      </div>
    );
  }

  const mainOrFeedClass =
    variant === 'main'
      ? 'friend-foxmask-placeholder-cutout--main final-partner-image'
      : 'friend-foxmask-placeholder-cutout--feed final-partner-image final-partner-image-feed';

  const heartInteractive = heartOverlayInteractive && typeof onHeartOverlayClick === 'function';

  const body = (
    <>
      <div
        className={`friend-foxmask-placeholder-cutout ${mainOrFeedClass}${jaggedClassName}`.trim()}
        aria-hidden="true"
      >
        <div className="friend-foxmask-placeholder-cutout__icon-wrap">
          <img src={foxMaskImage} alt="" className="friend-foxmask-placeholder-cutout__icon-img" />
        </div>
        <span className="friend-foxmask-placeholder-cutout__label">{label}</span>
      </div>
      {showHeartOverlay && heartSrc ? (
        <PartnerCutoutSpiritOverlay
          src={heartSrc}
          animate={animateHeart}
          pauseOffCenter={pauseHeartOffCenter}
          captureStill={captureHeartStill}
          alt=""
          className={heartClassName}
          onClick={heartInteractive ? onHeartOverlayClick : undefined}
          onKeyDown={heartInteractive ? onHeartOverlayKeyDown : undefined}
          role={heartInteractive ? 'button' : undefined}
          tabIndex={heartInteractive ? 0 : undefined}
          aria-label={heartInteractive ? heartOverlayAriaLabel : undefined}
        />
      ) : null}
    </>
  );

  if (!includeOuterImageWrapper) {
    return body;
  }

  return <div className="final-partner-image-wrapper">{body}</div>;
}
